<template>
  <Teleport to="body">
    <transition name="overlay-loader">
      <div v-if="visible"
        class="overlay-loader overlay-loader--fullscreen">
        <img :src="logo"
          alt="Laadimine..." />
      </div>
    </transition>
  </Teleport>
</template>

<script>
export default {
  name: 'overlay-loader',
  props: {
    visible: { type: Boolean, default: true },
    logo: { type: String, default: '/img/logo-tekstiga-valge.png' }
  }
}
</script>

<style lang="scss">
.overlay-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(30, 30, 30, 1);

  img {
    width: 170rem;
    margin-top: -10rem;
    animation: overlay-loader-pulse 1.4s ease-in-out infinite;
  }
}

.overlay-loader--fullscreen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgb(30, 30, 30);
}

@keyframes overlay-loader-pulse {
  0%,
  100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

.overlay-loader-leave-active {
  transition: opacity 0.5s ease;
}

.overlay-loader-leave-to {
  opacity: 0;
}

@include max-screen(640) {
  .overlay-loader img {
    width: 130rem;
  }
}
</style>
